import { Injectable } from '@angular/core';
import { ContactUsRequest } from '@mapa/esm';
import { Observable } from 'rxjs';
import { MapaApi } from './mapa.api';


@Injectable({
  providedIn: 'root'
})
export class ContactUsApi extends MapaApi {

  create(input: ContactUsRequest): Observable<void> {
    return this.http.post<void>(`${MapaApi.url}/contact-us`, input);
  }

}
